import { accentStyle, cn } from '../../lib/format.js'

const SIZES = {
  xs: 'size-6 rounded-md text-[9px]',
  sm: 'size-8 rounded-lg text-[10px]',
  md: 'size-10 rounded-xl text-xs',
  lg: 'size-14 rounded-2xl text-base',
  xl: 'size-20 rounded-2xl text-xl',
  '2xl': 'size-28 rounded-3xl text-2xl',
  // The match page banner: big on wide screens, still clear of its edges on phones.
  hero: 'size-24 rounded-3xl text-2xl sm:size-40 sm:text-4xl',
}

// A team's logo, or its tag on its accent color when there's no logo yet.
// Decorative by default because the team name is always shown next to it.
// `bare` shows a logo as it is, uncropped and with no tile, so a transparent
// one sits straight on the page.
export function TeamMark({ team, size = 'md', bare = false, className }) {
  if (!team) {
    return (
      <span
        aria-hidden="true"
        className={cn('grid shrink-0 place-items-center bg-white/5 font-display text-ink-muted ring-1 ring-white/10 ring-inset', SIZES[size], className)}
      >
        ?
      </span>
    )
  }
  if (team.logoUrl) {
    const tile = bare ? SIZES[size].split(' ').filter((c) => !c.startsWith('rounded')).join(' ') : SIZES[size]
    return <img src={team.logoUrl} alt="" className={cn('shrink-0', bare ? 'object-contain' : 'object-cover', tile, className)} />
  }
  return (
    <span
      aria-hidden="true"
      style={accentStyle(team.accent)}
      className={cn(
        'tint-soft tint-text tint-ring grid shrink-0 place-items-center font-display font-semibold tracking-wider ring-1 ring-inset',
        SIZES[size],
        className,
      )}
    >
      {team.tag}
    </span>
  )
}
